import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// layouts
import { AdminComponent } from "./layouts/admin/admin.component";
import { AuthComponent } from "./layouts/auth/auth.component";

// admin views
import { DashboardComponent } from "./views/admin/dashboard/dashboard.component";

// auth views
import { LoginComponent } from "./views/auth/login/login.component";
import { RegisterComponent } from "./views/auth/register/register.component";

// no layouts views
import { IndexComponent } from "./views/index/index.component";
import { LandingComponent } from "./views/landing/landing.component";
import { ProfileComponent } from "./views/profile/profile.component";
import { BlogComponent } from "./views/blog/blog.component";
import { BlogDetailComponent } from "./views/blog/blog-detail/blog-detail.component";
import { DoctorsListComponent } from "./views/doctor/doctors-list/doctors-list.component";
import { DoctorDetailComponent } from "./views/doctor/doctor-detail/doctor-detail.component";
import { VisitDetailComponent } from "./views/visit/visit-detail/visit-detail.component";
import { AccountInfoComponent } from "./views/admin/account-info/account-info.component";
import { AppointmentListComponent } from "./views/admin/appointment-list/appointment-list.component";
import { UserWalletComponent } from "./views/admin/user-wallet/user-wallet.component";
import { VisitLinkComponent } from "./views/visit/visit-link/visit-link.component";
import { AuthGuard } from "./shared/guards/auth.guard";
import { SilentRenewComponent } from "./silent-renew.component";
import { AboutUsComponent } from "./views/about-us/about-us.component";
import { PrivacyComponent } from "./views/privacy/privacy.component";
import { TermsComponent } from "./views/terms/terms.component";

const routes: Routes = [
  // no layout views
  { path: "", component: LandingComponent },
  { path: "profile", component: ProfileComponent },
  { path: "index", component: IndexComponent },
  { path: "blog", component: BlogComponent},
  { path: "blog-detail/:id", component: BlogDetailComponent},
  { path: "doctors-list", component: DoctorsListComponent},
  { path: "doctor-detail/:id", component: DoctorDetailComponent},
  { path: "visit-detail/:visitId", component: VisitDetailComponent, canActivate: [AuthGuard]},
  { path: "visit-link/:visitId", component: VisitLinkComponent, canActivate: [AuthGuard]},
  { path: "about-us", component: AboutUsComponent},
  { path: "privacy", component: PrivacyComponent},
  { path: "terms", component: TermsComponent},
  { path: 'silent-renew', component: SilentRenewComponent }, // Silent renew route
  // { path: "**", redirectTo: "", pathMatch: "full" },
  // user views
  {
    path: "user",
    component: AdminComponent,
    // canActivate: [AuthGuard],
    children: [{
      path: '',
      loadChildren: () => import('./views/admin/user-layout.module').then(m => m.UserLayoutModule)
    }],
  },
  // auth views
  {
    path: "auth",
    component: AuthComponent,
    children: [
      { path: "login", component: LoginComponent },
      { path: "register", component: RegisterComponent },
      { path: "", redirectTo: "login", pathMatch: "full" },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
